module.exports = __webpack_public_path__ + "img/monetizze.75f64ff1.svg";